import React from 'react';
import FactoryModel from '$fbusiness/models/factory';
import { IonFabButton, IonFabList } from '@ionic/react';
import { Button } from '$gcomponents/primitives';
import { Add } from '@mui/icons-material';
import StoreModel from '$fbusiness/models/store';
import PATH from '$business/enums/paths';
import { useHistory } from 'react-router';
import { itemText } from '$gbusiness/helpers/util';
import { IonFabWrapper } from './styles';
import { accessHide, getAccess, isAccessible } from '$fbusiness/helpers/util';

interface CreateNewFabsProps {
  currentState;
  factory: FactoryModel;
  onNewCharge: Function;
  onNewCredit: Function;
  store?: StoreModel;
}

const CreateNewFabs: React.FC<CreateNewFabsProps> = ({
  currentState,
  factory,
  onNewCharge,
  onNewCredit,
  store,
}) => {
  const history = useHistory();
  const { settings } = factory;
  const ACCESS = getAccess(currentState);

  const canCreateInvoice = isAccessible(ACCESS.ACTION.INVOICE.CREATE, currentState);
  const canCreateRefund = isAccessible(ACCESS.ACTION.REFUND.CREATE, currentState);
  const canCreateCredit = isAccessible(ACCESS.ACTION.CREDIT.CREATE, currentState);
  const canCreateCharge = isAccessible(ACCESS.ACTION.CHARGE.CREATE, currentState);
  const canDoNothing = !canCreateCredit && !canCreateInvoice && !canCreateRefund;

  const onNewRefund = () => {
    if (!isAccessible(ACCESS.ACTION.CREDIT.CREATE, currentState)) {
      navRefund(false);
      return;
    }
    navRefund(false);
  };

  const onNewInvoice = (invoiceId = 0) => {
    if (store?.id) {
      history.push(`${PATH.INVOICE}/0/${invoiceId || '0'}/${store?.id}`);
      return;
    }
    history.push(`${PATH.INVOICE}/0/${invoiceId || '0'}`);
  };

  const navRefund = (isCredit) => {
    const path = isCredit ? PATH.CREATE_CREDIT : PATH.CREATE_REFUND;
    if (store?.id) {
      history.push(`${path}/0/${store.id}`);
      return;
    }
    history.push(`${path}/0`);
  };

  const enableFab = settings?.createInvoice || settings?.refundVoucher;
  if (!enableFab) return null;

  return (
    <IonFabWrapper
      className={`add-fab no-print ${canDoNothing ? 'hide' : ''}`}
      vertical="top"
      horizontal="end"
      slot="fixed">
      <IonFabButton size="small">
        <Add />
      </IonFabButton>
      <IonFabList side="bottom">
        <Button
          icon={<Add />}
          className={accessHide(ACCESS.ACTION.INVOICE.CREATE)}
          variant="outlined"
          onClick={(e) => onNewInvoice()}>
          {itemText('CREATE_NEW', 'INVOICE')}
        </Button>
        {canCreateCharge && (
          <Button
            icon={<Add />}
            className={accessHide(ACCESS.ACTION.CHARGE.CREATE)}
            variant="outlined"
            onClick={(e) => onNewCharge(store)}>
            {itemText('CREATE_NEW', 'CHARGE')}
          </Button>
        )}
        {canCreateCredit && (
          <Button
            icon={<Add />}
            className={accessHide(ACCESS.ACTION.CREATE_CREDIT)}
            variant="outlined"
            onClick={(e) => onNewCredit(store)}>
            {itemText('CREATE_NEW', 'CREDIT')}
          </Button>
        )}
        {factory?.settings?.refundVoucher && canCreateRefund && (
          <Button
            icon={<Add />}
            className={canCreateRefund ? '' : 'hide'}
            variant="outlined"
            onClick={onNewRefund}>
            {itemText('CREATE_NEW', 'REFUND')}
          </Button>
        )}
      </IonFabList>
    </IonFabWrapper>
  );
};

export default CreateNewFabs;
